module.exports = __webpack_public_path__ + "static/media/the-simple-shellfish-oysters.14a61a5a.jpg";